import { toast } from '@postscript/components';
import { useQuery } from '@tanstack/react-query';
import { COMPLIANCE_AI_ELIGIBILITY_IN_APP } from 'components/admin/utils/feature-flags';
import { usePSLabs } from 'controllers/contexts/labsFeatures';
import { api } from 'controllers/network/apiClient';
import { useEffect } from 'react';

export interface CountAndPercent {
  count: number;
  percent: number;
}

export interface AiEligibleSummary {
  totalActiveSubscribers: number;
  aiEligible: CountAndPercent;
  aiIneligible: CountAndPercent;
  change: number | null;
  changeL90: number | null;
  periodLabel: string;
}

const fetchAiEligibleSummary = async (): Promise<AiEligibleSummary> =>
  api.get('/v2/ai-components/eligibility/metrics');

const ERROR_TOAST_MESSAGE =
  'Something went wrong loading your AI eligibility data. Try refreshing the page or contact us if the problem persists.';

export const useAiEligibleSubscribers = () => {
  const { hasLabsFlag } = usePSLabs();
  const isAiEligibilityInAppEnabled = hasLabsFlag(
    COMPLIANCE_AI_ELIGIBILITY_IN_APP,
  );

  const result = useQuery({
    queryKey: ['ai-eligible-subscribers'],
    queryFn: fetchAiEligibleSummary,
    enabled: isAiEligibilityInAppEnabled,
    staleTime: 1000 * 60 * 15,
  });

  useEffect(() => {
    if (result.error) {
      toast.error(ERROR_TOAST_MESSAGE);
    }
  }, [result.error]);

  return result;
};
